import { SITE } from '@/app/constants';
import type { TaskInfo } from '@/app/types';
import { IP_LOCATION_WHITELIST, OFFICIAL_IP_LOCATION, UNKNOWN_IP_LOCATION } from './constants';

export const getDisplayIpLocation = (
  userId: string | undefined,
  ipLocation: string | undefined,
): string | undefined => {
  if (SITE !== 'china') return undefined;
  if (userId && IP_LOCATION_WHITELIST.includes(userId)) {
    return OFFICIAL_IP_LOCATION;
  }
  return ipLocation || UNKNOWN_IP_LOCATION;
};

export function getTaskInputs(task?: TaskInfo) {
  if (!task) return null;

  const { input, settings, type, scene } = task;
  const { prompts = [] } = input;

  const isProMode = input.editor_mode === 'professional';
  const textPrompt = prompts.filter((p) => p.type === 'text').map((p) => p.content)?.[0] || '';
  const mediaPrompts = prompts.filter((p) => p.type === 'image' || p.type === 'material' || p.type === 'video');
  const audioPrompts = prompts.filter((p) => p.type === 'text') || [];

  // 1.0 模型只有两个版本，vidu-high-quality 和 vidu-high-performance，此处兼容可能 modal 为 vidu 或者其他值
  if (settings.model_version === '1.0') {
    const currentModel = settings.model === 'vidu-high-quality' ? 'vidu-high-quality' : 'vidu-high-performance';
    settings.model = currentModel;
  }
  return {
    taskType: type,
    settings,
    mediaPrompts,
    audioPrompts,
    textPrompt,
    isProMode,
    templateScene: scene,
    prompts,
  };
}
